import React from 'react';
import { ChevronLeftArrow } from '../../../../SVG';
import { THEME } from '../../../../clearstep/util/Theme';
import PartnerLogo from '../../../../tailwind_clearstep/PartnerLogo/PartnerLogo';
import '../../../utils/Flows';
import { WidgetStateChangeType } from '../../Widget';
export var WidgetHeaderContent = function (props) {
    var _a;
    var setWorkflow = props.setWorkflow, headerText = props.headerText;
    var customTheme = ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.widgetHeaderTheme) || {};
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "group ml-4 flex items-center font-semibold leading-7 hover:cursor-pointer", tabIndex: 0, onClick: function () { return setWorkflow(null, WidgetStateChangeType.MANUAL); } },
            React.createElement(ChevronLeftArrow, { fill: THEME.primaryColor }),
            React.createElement("span", { className: "ml-1 text-xl font-medium text-primary" }, headerText)),
        React.createElement(PartnerLogo, { customLogoPath: customTheme.logoPath, enableLogoLink: false, imageClassName: "w-21.5 mr-4" })));
};
export default WidgetHeaderContent;
